import { getFirestore, collection, getDocs } from 'firebase/firestore';
import { saveAs } from 'file-saver';
import Papa from 'papaparse';

const db = getFirestore();

export const exportOrdersAsCSV = async () => {
  const ordersSnap = await getDocs(collection(db, 'orders'));

  const rows = [];

  ordersSnap.docs.forEach(doc => {
    const data = doc.data();
    const customerInfo = data.customerInfo || {};
    const shippingAddress = data.shippingAddress || {};
    const items = data.items || [];

    if (items.length > 0) {
      items.forEach(item => {
        const customization = item.customization || {};

        rows.push({
          name: customerInfo.name || '',
          email: customerInfo.email || '',
          street: customerInfo.street || '',
          city: customerInfo.city || '',
          state: customerInfo.state || '',
          zip: customerInfo.zip || '',
          productName: item.name || '',
          productId: item.id || '',
          size: item.selectedSize || '',
          logo: item.logo || '',
          color: item.color || '',
          price: item.price ?? '',
          quantity: item.quantity ?? '',
          totalAmount: data.totalAmount || '',
          addName: customization.addName ? 'Yes' : 'No',
          addNumber: customization.addNumber ? 'Yes' : 'No',
          playerName: customization.playerName || '',
          playerNumber: customization.playerNumber || '',
          stripePaymentIntentId: data.stripePaymentIntentId || '',
          createdAt: data.createdAt?.toDate().toISOString() || '',
          image: item.image || '',
          userId: data.userId || '',
          shippingStreet: shippingAddress.street || '',
          shippingCity: shippingAddress.city || '',
          shippingState: shippingAddress.state || '',
          shippingZip: shippingAddress.zip || ''
        });
      });
    } else {
      const customization = data.customization || {};

      rows.push({
        name: customerInfo.name || '',
        email: customerInfo.email || '',
        street: customerInfo.street || '',
        city: customerInfo.city || '',
        state: customerInfo.state || '',
        zip: customerInfo.zip || '',
        productName: data.name || '',
        productId: data.id || '',
        size: data.selectedSize || '',
        logo: data.logo || '',
        color: data.color || '',
        price: data.price ?? '',
        quantity: data.quantity ?? '',
        totalAmount: data.totalAmount || '',
        addName: customization.addName ? 'Yes' : 'No',
        addNumber: customization.addNumber ? 'Yes' : 'No',
        playerName: customization.playerName || '',
        playerNumber: customization.playerNumber || '',
        stripePaymentIntentId: data.stripePaymentIntentId || '',
        createdAt: data.createdAt?.toDate().toISOString() || '',
        image: data.image || '',
        userId: data.userId || '',
        shippingStreet: shippingAddress.street || '',
        shippingCity: shippingAddress.city || '',
        shippingState: shippingAddress.state || '',
        shippingZip: shippingAddress.zip || ''
      });
    }
  });

  const csv = Papa.unparse(rows);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  saveAs(blob, 'orders.csv');
};
